import React from 'react';
import { Overlay } from '@thd-olt-component-react/core-ui';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

const PortfolioVideoOverlay = ({ video, onClose }) => {

  const processSrc = ({ type, id }) => {
    switch (type) {
    case 'youtube':
      return `https://www.youtube.com/embed/${id}`;
    case 'vimeo':
      return `https://player.vimeo.com/video/${id}`;
    default:
      return '';
    }
  };

  if (!video.id || !video.type) {
    return null;
  }

  return (
    <Overlay
      open
      onClose={onClose}
      modalClass="p2p-overlay"
    >
      <button
        tabIndex={-1}
        aria-label="close"
        className="p2p-portfolio__overlay-close-button"
        data-testid="video-overlay-close"
        onClick={onClose}
      >
        <CloseIcon style={{ fontSize: '5rem' }} />
      </button>
      <iframe
        frameBorder="0"
        className="p2p-portfolio__video-iframe"
        src={processSrc(video)}
        allowFullScreen
        title="Portfolio Video"
      />
    </Overlay>
  );
};

export default PortfolioVideoOverlay;

PortfolioVideoOverlay.propTypes = {
  video: PropTypes.shape({
    type: PropTypes.oneOf(['youtube', 'vimeo', '']),
    id: PropTypes.string
  }),
  onClose: PropTypes.func.isRequired
};

PortfolioVideoOverlay.defaultProps = {
  video: {}
};
